import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { AlertDialog } from 'shell/components';

const DialogContext = createContext({});
const useDialog = () => useContext(DialogContext);

const DialogProvider = ({ children }) => {
    const [dialog, setDialog] = useState({
        open: false,
        message: '',
        description: '',
        note: '',
        variant: 'primary',
        actionButtonText: '',
        cancelButtonText: '',
        onAction: () => {},
        onCancel: () => closeDialog(),
        onClose: () => closeDialog(),
    });

    const closeDialog = useCallback(() => {
        setDialog((current) => {
            return { ...current, open: false, onAction: () => {} };
        });
        setTimeout(() => {
            setDialog({
                open: false,
                message: '',
                description: '',
                note: '',
                variant: 'primary',
                actionButtonText: '',
                cancelButtonText: '',
                onAction: () => {},
                onCancel: () => closeDialog(),
                onClose: () => closeDialog(),
            });
        }, 150);
    }, []);

    useEffect(() => {
        const handlePopState = () => {
            if (dialog.open) closeDialog();
        };

        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [closeDialog, dialog.open]);

    const value = useMemo(
        () => ({
            dialog,
            setDialog,
            closeDialog,
        }),
        [dialog, closeDialog]
    );

    return (
        <DialogContext.Provider value={value}>
            {children}
            <AlertDialog {...dialog} />
        </DialogContext.Provider>
    );
};

export { useDialog };
export default DialogProvider;
